/**
 * Sokan before/after previews — screens behind login or a real booking, rendered
 * from sample data so the updates bot can screenshot the previous and the new
 * build side by side and put a «قبل/بعد» card under the digest.
 *
 * `page` is the real route the preview stands for; the bot only attaches a card
 * to a digest about that page. Add an entry when you add a /sokan-preview page,
 * and mark each independent block with `data-preview="<key>"`: the bot compares
 * blocks by key, so a block added in the middle does not read as a page-wide change.
 */
export const SOKAN_PREVIEWS = [
  { path: '/sokan-preview/receipt-timeline/', page: '/receipt/' },
  { path: '/sokan-preview/factor/', page: '/factor/' },
  { path: '/sokan-preview/payment-sheet/', page: '/factor/' },
  { path: '/sokan-preview/doctor-home/', page: '/_/' },
  { path: '/sokan-preview/vardast/', page: '/_/chats/' },
];

/** Only the bot's throwaway shot pod sets SOKAN_PREVIEW=1; everywhere else these 404. */
export const sokanPreviewEnabled = () => process.env.SOKAN_PREVIEW === '1';

/**
 * The team's own test doctor (online-visit center) — public profile data only,
 * so previews that need a doctor show real, non-personal data.
 */
export const PREVIEW_DOCTOR = {
  slug: 'دکتر-امیرحسین-بیگی',
  name: 'امیرحسین بیگی',
  userCenterId: '9b87618a-62db-482b-8b96-ae94a92039d5',
  serviceId: '9b87618a-66bc-407d-99af-c8b89296e17c',
};
